export default __webpack_public_path__ + "static/media/shutterstock.5b0f5cad.jpg";